// extracted by mini-css-extract-plugin
export default {"TipsContainer":"HelpPanelTips_TipsContainer__R+gyj","TipText":"HelpPanelTips_TipText__ESHvr"};